import {
  ModalLayout,
  Pagination,
  SearchFilters,
  // Table,
} from "@wac-ui-dashboard/wac_component_library";
import React from "react";
import usePhotoSectionTable from "./usePhotoSectionTable";
import { FaSort } from "react-icons/fa";
import Upload from "./Upload";
import { ProfileCard } from "../../../Master/Branches/ProfileCard";
import RemarksTable from "../../../Global/RemarksTable";
import Style from "../photosection.module.scss";
import BulkUpload from "./BulkUpload";
import PhotoUploadWorkModal from "./PhotoUploadWorkModal";
import {Table} from "../../../Global/Table";

const PhotoSectionTable = ({ gliNumber }) => {
  const {
    state,
    tableData,
    tableFields,
    imageData,
    showImageModal,
    paginationOptions,
    isFetching,
    globalRemarkModal,
    getRow,
    refetch,
    closeModal,
    handlePagination,
    handlePageSize,
    handleModalClose,
    handleUploadModalClick,
    handleUploadModalClose,
    handleBulkUploadModalClose,
    handleBulkImageUploadClick,
    handleSearch,
    isLoading,
    handlePhotoUploadWork,
  } = usePhotoSectionTable();
  return (
    <div>
      <h6 className="pro-ttl h6">{gliNumber}</h6>
      <div className="search-wrap lg">
        <SearchFilters
          onSearchInput={handleSearch}
          SearchIcon={
            <span className="material-symbols-outlined"> search </span>
          }
          showClearFilters={false}
          searchInputProps={{
            value: state?.pendingSearch,
            placeholder: "Search Certificate Number, Design ID",
          }}
          showActions={false}
          // handleActionClick={handleEditColumnsClick}
          loading={isLoading}
          filterChildren={
            <div className="col pro-d-flex pro-justify-end">
              <button
                className={`${Style.Print_btn} ${Style.raw_btn} pro-btn pro-items-center pro-mx-2
            ${state.rawPhotoWorkCompleted ? "outline-success" : "pro-btn-outline"}`}
                onClick={handlePhotoUploadWork}
                disabled={state.rawPhotoWorkCompleted}
              >
                <span className="material-symbols-outlined">
                  {state.rawPhotoWorkCompleted ? "check" : "assignment"}
                </span>
                <span>Raw Photo Work</span>
              </button>
              <button
                className={`${Style.Print_btn} pro-btn pro-items-center pro-btn-outline lg`}
                onClick={handleBulkImageUploadClick}
              >
                <span className="material-symbols-outlined">check_circle</span>
                <span>Bulk Upload</span>
              </button>
            </div>
          }
          className="search-input"
        />
      </div>
      <Table
        multiSelect={false}
        data={tableData?.data?.data ?? []}
        uniqueID={"_id"}
        fields={tableFields}
        SortIcon={<FaSort />}
        assignIcon={
          <span className="material-symbols-outlined">cloud_upload</span>
        }
        getRow={getRow}
        loading={isFetching}
        perpage={state?.currentTablePageSize}
        assignable={true}
        deletable={false}
        showCheckBox={true}
        editable={false}
        handleAssign={handleUploadModalClick}
        assignText={`Upload`}
        clear={state?.clear}
      />
      {tableData?.data?.data && (
        <Pagination
          currentPage={parseInt(tableData?.data?.current_page)}
          totalPageCount={Math.ceil(
            tableData?.data?.total_count / tableData?.data?.per_page,
          )}
          onPageChange={handlePagination}
          options={paginationOptions}
          onActionChange={handlePageSize}
          center
        />
      )}
      <ModalLayout
        show={state.uploadModal}
        handleClose={handleUploadModalClose}
        title={`Upload Photo`}
        closeIcon={<span className="material-symbols-outlined"> close </span>}
      >
        <div className="pro-m-5">
          <Upload refetch={refetch} tableType={tableData?.data?.table_type} />
        </div>
      </ModalLayout>

      <ModalLayout
        show={state.bulkUploadModal}
        handleClose={handleBulkUploadModalClose}
        title={`Upload Photos`}
        closeIcon={<span className="material-symbols-outlined"> close </span>}
      >
        <div className="pro-m-5">
          <BulkUpload
            refetch={refetch}
            tableType={tableData?.data?.table_type}
            values={state.values}
            errors={state.errors}
          />
        </div>
      </ModalLayout>

      <ModalLayout show={showImageModal} handleClose={closeModal}>
        <ProfileCard data={imageData} handleClose={closeModal} />
      </ModalLayout>
      <ModalLayout
        show={globalRemarkModal}
        handleClose={handleModalClose}
        title={"Remarks"}
        propStyle={{ root: "pro-modal-xxl" }}
        closeIcon={<span className="material-symbols-outlined">close</span>}
      >
        <div className="pro-m-5">
          <RemarksTable />
        </div>
      </ModalLayout>
      <ModalLayout
        show={state.showPhotUploadWorkModal}
        handleClose={handlePhotoUploadWork}
        title={"Submit Photo Upload Work"}
        centered
        closeIcon={<span className="material-symbols-outlined">close</span>}
        backdrop="static"
      >
        <div className="pro-m-5">
          <PhotoUploadWorkModal
            handleClose={handlePhotoUploadWork}
            refetch={refetch}
            state={state}
          />
        </div>
      </ModalLayout>
    </div>
  );
};

export default PhotoSectionTable;
